// The SPA's view of the backend session: /ui/session, /ui/login, /ui/logout, /setlang.
// Calls go to the configured backend (core/backend.js): same origin behind the
// Vite/Pages proxy with the session cookie, or cross-origin with the session token
// header when wb allows this origin.
import { apiFetch } from './backend.js';

export const session = {
  data: null, // last /ui/session payload
};

async function jsonFetch(url, init = {}) {
  const resp = await apiFetch(url, init);
  let body = null;
  try {
    body = await resp.json();
  } catch (e) {
    body = null;
  }
  if (!resp.ok) {
    const err = new Error((body && body.msg) || resp.status + ' ' + resp.statusText);
    err.status = resp.status;
    err.body = body;
    throw err;
  }
  return body;
}

function form(fields) {
  const p = new URLSearchParams();
  for (const k of Object.keys(fields)) p.set(k, fields[k]);
  return { method: 'POST', body: p, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
}

export async function fetchSession() {
  session.data = await jsonFetch('/ui/session');
  return session.data;
}

export async function login(username, password) {
  return jsonFetch('/ui/login', form({ username, password }));
}

export async function logout() {
  try {
    await jsonFetch('/ui/logout', form({}));
  } finally {
    session.data = null;
    try {
      // strings are per language, not per user, but drop them so a switch is clean
      Object.keys(sessionStorage)
        .filter((k) => k.startsWith('wb.'))
        .forEach((k) => sessionStorage.removeItem(k));
    } catch (e) {
      /* ignore */
    }
  }
}

export async function setLanguage(code) {
  return jsonFetch('/setlang', form({ name: 'lang', value: code, pk: (session.data && session.data.user && session.data.user.username) || '' }));
}

export function isAuthenticated() {
  return !!(session.data && session.data.authenticated);
}
